import { render, staticRenderFns } from "./SolicitacaoRespostaFreteLista.vue?vue&type=template&id=2fcdc85b"
import script from "./SolicitacaoRespostaFreteLista.vue?vue&type=script&lang=js"
export * from "./SolicitacaoRespostaFreteLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports